module.exports = __webpack_public_path__ + "img/euvsviruslogo.707a1a20.svg";